import { render } from "./KisiGrup.vue?vue&type=template&id=21946742&scoped=true"
import script from "./KisiGrup.vue?vue&type=script&lang=js"
export * from "./KisiGrup.vue?vue&type=script&lang=js"

import "./KisiGrup.vue?vue&type=style&index=0&id=21946742&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21946742"]])

export default __exports__